/**
 * Software Overview — 離籍者（ALUMNI）ソフト別集計 Frontend ローカル Contract
 *
 * BE 側 `dresscode-backend/v2/src/it-force/api/app-overview/usecase/software-overview-tenant-alumni-app-user.api-contract.ts`
 * と同じ Zod 構造を再現する。BE が `@standandforce/api-contract` に publish された後、
 * client.ts のローカル import を廃し、`orpc.software.overviewTenantAlumniAppUser`
 * （published `softwareContract` 由来）へ差し替える想定。
 *
 * path は BE Controller の最終 URL を指定する（FE の OpenAPILink はフル URL を必要とするため）。
 * BE 側 route は休眠（INACTIVE）と同型だが、月次スナップショットが無いため
 * monthOverMonthChange は返さない。
 */
import { oc } from '@orpc/contract';
import { z } from 'zod';
const AlumniAppUserSummarySchema = z.object({
  appIntegrationId: z.string(),
  appId: z.string(),
  avatarUrl: z.string(),
  count: z.number()
});
const GetSoftwareOverviewTenantAlumniAppUserOutputSchema = z.object({
  total: z.number(),
  partialList: z.array(AlumniAppUserSummarySchema)
});
export const softwareOverviewAlumniContract = oc.router({
  overviewTenantAlumniAppUser: oc.route({
    method: 'GET',
    path: '/v2/software/overview/alumni-app-user'
  }).input(z.object({})).output(GetSoftwareOverviewTenantAlumniAppUserOutputSchema)
});